export default __webpack_public_path__ + "static/media/business-wallpaper.0114386e.jpg";